import { Module } from "vuex";
import { RootState } from "..";
import { PANEL_ACTIONS } from "./panel.actions";
import { PANEL_MUTATIONS } from "./panel.mutations";
import { PANEL_GETTERS } from "./panel.getters";
import { GlobalPagination } from "@/interfaces/panel/global-pagination.model";
import { UserAcceptedAuthModel } from "@/interfaces/users/user-accepted-auth.model";
import { GetUserModel } from "@/interfaces/users/get-user.model";
import { SystemSettingsModel } from "@/interfaces/panel/system-settings.model";
import { ManualCharge, ManualChargeFilters, ManualChargePagination } from "@/interfaces/panel/manual-charge.model";
import { GatewaySettlementSettings } from "@/interfaces/panel/gateway-settlement-settings";

export interface PanelState {
    loading: boolean;
    globalPagination: GlobalPagination;
    globalActivePage: number;
    // sayyarpay
    allUsers: GetUserModel[];
    notVerifiedUsers: GetUserModel[];
    userInfo: GetUserModel;
    userAcceptedAuth: UserAcceptedAuthModel;
    systemLogs: unknown[];
    userTransactions: unknown[];
    externalTransactions: unknown[];
    userExternalTransactions: unknown[];
    allWithdrawals: unknown[];
    userWithdrawals: unknown[];
    systemSettings: SystemSettingsModel;
    gateways: unknown[];
    gatewayInfo: Record<string, unknown> | null;
    gatewayTransactions: unknown[];
    commissions: unknown[];
    depositTransferHistory: unknown[];
    gatewaySettlementSettings: GatewaySettlementSettings | null;
    manualCharges: ManualCharge[];
    manualChargesPagination: ManualChargePagination;
    manualChargesFilters: ManualChargeFilters;
    manualChargesLoading: boolean;
    manualChargeActionLoading: Record<string, boolean>;
    withdrawalsCrypto: unknown[];
    userFinancialLogs: any[];
    userStatement: {
        logs: any[];
        summary: {
            totalRiali: number;
            totalUSDT: number;
            totalLogs: number;
            financialBreakdown?: {
                riali: {
                    income: number;
                    expense: number;
                    netChange: number;
                    formattedIncome: string;
                    formattedExpense: string;
                    formattedNetChange: string;
                };
                usdt: {
                    income: number;
                    expense: number;
                    netChange: number;
                    formattedIncome: string;
                    formattedExpense: string;
                    formattedNetChange: string;
                };
            };
        };
        pagination: {
            page: number;
            pageSize: number;
            totalItems: number;
            totalPages: number;
            hasMore: boolean;
        };
        user?: {
            id: string;
            name: string;
            email: string;
        };
    };
    paymentSetting: any,
    exchangeSetting: any,
    totalTransactionsAmount: number
}

const INITIAL_STATE: PanelState = {
    loading: false,

    globalPagination: {
        page: 1,
        pages: 1,
        total: 1,
        limit: 50
    },

    globalActivePage: 1,

    // sayyarpay
    allUsers: [],

    notVerifiedUsers: [],

    userInfo: {
        id: "",
        name: "",
        email: "",
        image: "",
        wallet: "",
        withdrawn: "",
        role: ""
    },

    userAcceptedAuth: {
        id: "",
        userId: "",
        trackingCode: "",
        firstName: "",
        nationalCode: "",
        birthDate: "",
        gender: "",
        cardBackNumber: "",
        nationalImageUrl: "",
        selfieImageUrl: "",
        status: "",
        submittedAt: "",
        reviewedAt: "",
        reviewNotes: ""
    },

    systemLogs: [],
    userTransactions: [],
    externalTransactions: [],
    userExternalTransactions: [],
    allWithdrawals: [],
    userWithdrawals: [],

    systemSettings: {
        id: "",
        commissionGateway: 0,
        commissionGatewayAuth: 0,
        commissionSwapRIALI: 0,
        Transfer_fixedFeeRiali: 0,
        Transfer_percentageFeeRiali: 0,
        Transfer_fixedFeeUsdt: 0,
        Transfer_percentageFeeUsdt: 0,
        withdraw_fixedFeeRiali: 0,
        withdraw_percentageFeeRiali: 0,
        withdraw_fixedFeeUsdt: 0,
        withdraw_percentageFeeUsdt: 0,
        withdraw_maximumRiali: 0,
        charge_maximumRiali: 0,
        supportId: null,
        updatedAt: "",
        bankName: "",
        cardNumber: null,
        cardOwner: null,
        isCardChargeEnabled: false,
        isShebaChargeEnabled: false,
        shebaNumber: null,
        depositNumber: null,
        shebaOwner: null,
        charge_minimumRiali: 0,
        charge_minimumCrypto: 0,
        withdraw_minimumRiali: 0,
        withdraw_minimumUsdt: 0
    },

    gateways: [],
    gatewayInfo: null,
    gatewayTransactions: [],
    commissions: [],
    depositTransferHistory: [],
    gatewaySettlementSettings: null,
    manualCharges: [],
    manualChargesPagination: {
        page: 1,
        pageSize: 20,
        totalItems: 0,
        totalPages: 0
    },
    manualChargesFilters: {
        status: "ALL",
        chargeType: "ALL",
        page: 1,
        pageSize: 20
    },
    manualChargesLoading: false,
    manualChargeActionLoading: {},
    withdrawalsCrypto: [],
    userFinancialLogs: [],
    userStatement: {
        logs: [],
        summary: {
            totalRiali: 0,
            totalUSDT: 0,
            totalLogs: 0,
            financialBreakdown: undefined
        },
        pagination: {
            page: 1,
            pageSize: 50,
            totalItems: 0,
            totalPages: 0,
            hasMore: false
        },
        user: null
    },
    paymentSetting: {
        rialiDefaultSettlementType: "INSTANT",
        rialiTransactionFeeCap: 0,
        rialiCycleSettlementTime: "11:15",
        usdtDefaultSettlementType: "CYCLE",
        usdtMinimumSettlement: 0,
        defaultFeePayerType: "BUSINESS",
        rialiCycleFixedFee: 0,
        rialiCyclePercentageFee: 0,
        rialiInstantFixedFee: 0,
        rialiInstantPercentageFee: 0,
        usdtCycleFixedFee: 0,
        usdtCyclePercentageFee: 0,
        usdtInstantFixedFee: 0,
        usdtInstantPercentageFee: 0,
        rialiInstantFeeCap: 0
    },

    exchangeSetting: {},
    totalTransactionsAmount: 0
};

export const panel: Module<PanelState, RootState> = {
    actions: PANEL_ACTIONS,
    getters: PANEL_GETTERS,
    mutations: PANEL_MUTATIONS,
    state: INITIAL_STATE,
    namespaced: true,
};
